<script>
export default {
  name: "CrmNewsCard",
  props: {
    item: {
      type: Object,
      required: true
    },
    dataTest: {
      type: String,
      default: "news-card"
    },
    dateFormat: {
      type: String,
      default: "DD MMM YYYY"
    }
  },
  emits: ["select"],
  computed: {
    title() {
      return this.item.news_language?.[0]?.name || this.item.name || "-";
    },
    description() {
      return (
        this.item.news_language?.[0]?.short_description ||
        this.item.short_description ||
        ""
      );
    },
    createdDate() {
      if (!this.item.created_date) return "-";
      return this.$dateFormat(this.item.created_date);
    },
    imageSrc() {
      return this.item.image_url || this.handleImageSrc;
    }
  },
  methods: {
    selectCard() {
      this.$emit("select", this.item);
    }
  }
};
</script>

<template>
  <button
    type="button"
    class="crm-news-card"
    :data-test="dataTest"
    @click="selectCard"
  >
    <c-img-lazy :src="imageSrc" class="crm-news-card__image" />
    <span class="crm-news-card__content">
      <span>{{ title }}</span>

      <div class="crm-card__meta justify-content-between mt-auto">
        <!-- <div>
          <span data-lang="create_date">{{ $t("create_date") }}</span> <span>{{ createdDate }}</span>
        </div> -->
        <c-btn class="f-body-sm ml-auto" variant="custom-link">
          {{ $t("discover") }}
          <font-awesome-icon
            class="ml-2"
            icon="chevron-right"
          ></font-awesome-icon>
        </c-btn>
      </div>
    </span>
  </button>
</template>

<style lang="scss" scoped>
.crm-news-card {
  display: grid;
  width: 100%;
  // height: 120px;
  grid-template-columns: 33% minmax(0, 1fr);
  overflow: hidden;
  margin-bottom: 12px;
  border: 1px solid var(--crm-border-color);
  border-radius: var(--crm-border-radius);
  background: var(--crm-card-backgroud);
  box-shadow: var(--crm-box-shadow);
  text-align: left;
}

.crm-news-card__image {
  width: 100%;
  height: auto;
  // max-height: 106px;
}

.crm-news-card__image :deep(.v-img) {
  height: 100%;
}

.crm-news-card__content {
  display: flex;
  min-width: 0;
  flex-direction: column;
  padding: 9px 10px;
  // background-color: var(--secondary-color);
}

.crm-news-card__content span,
.crm-news-card__content small {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
}

.crm-news-card__content span {
  font-size: var(--font-body);
  // line-height: 1.25;
  -webkit-line-clamp: 2;
}

.crm-news-card__content small {
  color: #9a9a9a;
  font-size: var(--font-body-sm);
  // line-height: 1.35;
  -webkit-line-clamp: 2;
}

// .crm-news-card__date {
//   display: flex;
//   justify-content: space-between;
//   gap: 8px;
//   margin-top: auto;
//   color: var(--text-secondery-color);
//   font-size: var(--font-body-sm);
//   font-weight: 800;
// }
</style>
